import { render, staticRenderFns } from "./AnalisaKasusForm.vue?vue&type=template&id=626b0a7f&scoped=true"
import script from "./AnalisaKasusForm.vue?vue&type=script&lang=js"
export * from "./AnalisaKasusForm.vue?vue&type=script&lang=js"
import style0 from "./AnalisaKasusForm.vue?vue&type=style&index=0&id=626b0a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b0a7f",
  null
  
)

export default component.exports